export const appsApiDashboardQuery = "/apps/api_dashboard/query";
